import { render, staticRenderFns } from "./ScanReportModal.vue?vue&type=template&id=28792f79&scoped=true&style=top%3A%2020px"
import script from "./ScanReportModal.vue?vue&type=script&lang=ts"
export * from "./ScanReportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28792f79",
  null
  
)

export default component.exports